import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

const Pricing = () => {
  const { t } = useLang();

  return (
    <section
      id="pricing"
      className="relative px-6 md:px-10 py-24 md:py-32 border-t border-white/10"
      data-testid="pricing-section"
    >
      <div className="max-w-[1500px] mx-auto">
        <div className="text-xs uppercase tracking-[0.3em] text-[#ff00cc] mb-6">
          {t.sectionLabels.pricing}
        </div>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="font-display text-[10vw] md:text-6xl lg:text-7xl whitespace-pre-line max-w-4xl"
        >
          {t.pricing.title}
        </motion.h2>
        <p className="mt-6 text-white/60 max-w-2xl text-base md:text-lg leading-relaxed">
          {t.pricing.sub}
        </p>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.pricing.items.map((item, i) => (
            <motion.article
              key={item.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className={`relative border border-white/10 rounded-3xl p-7 md:p-8 bg-[#131313] flex flex-col cursor-default ${
                item.popular ? "ring-2 ring-[#ff4500] ring-offset-2 ring-offset-[#0a0a0a]" : ""
              }`}
              style={{ "--accent": item.accent }}
            >
              {item.popular && (
                <span className="absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full text-xs font-medium uppercase tracking-wider bg-[#ff4500] text-black">
                  Popular
                </span>
              )}
              <div className="flex items-start justify-between">
                <span className="font-display text-3xl text-white/30">
                  {item.n}
                </span>
              </div>
              <div className="mt-6">
                <h3 className="font-display text-2xl md:text-3xl mb-2">{item.title}</h3>
                <p className="text-sm text-white/50 mb-4">{item.highlight}</p>
                <div className="flex items-baseline gap-2 mb-6">
                  <span className="font-display text-4xl md:text-5xl" style={{ color: item.accent }}>
                    {item.price}
                  </span>
                  {item.period && (
                    <span className="text-white/50">{item.period}</span>
                  )}
                </div>
                <ul className="space-y-3 mb-8">
                  {item.features.map((feat, j) => (
                    <li key={j} className="flex items-center gap-3 text-white/70 text-sm">
                      <CheckCircle2 size={18} style={{ color: item.accent }} />
                      {feat}
                    </li>
                  ))}
                </ul>
                <button
                  className="w-full py-3 px-6 rounded-2xl font-medium transition-all"
                  style={{
                    backgroundColor: item.accent,
                    color: "black"
                  }}
                >
                  {item.cta}
                </button>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;
